import { AccountFilterCombobox } from '@/features/quotes/components/AccountFilterCombobox';

/** Optional customer for an ask. The quotes picker's "all" entry means "no customer named". */
export function CustomerPicker({ value, onChange, disabled }: {
  value: string | null;
  onChange: (accountId: string | null) => void;
  disabled?: boolean;
}) {
  return (
    <div role="group" aria-label="Customer">
      <AccountFilterCombobox
        value={value ?? 'all'}
        onChange={(id) => onChange(id === 'all' ? null : id)}
        placeholder="No customer named"
        disabled={disabled}
        className="w-full"
      />
    </div>
  );
}
